import { Button } from '@mui/material';
import { IconFilter, IconRepeat } from '@tabler/icons-react';
import { useFiltersContext } from './hooks/useFiltersContext';
import PDFGeneratorButton from './PDF/PDFGeneratorButton';

export const Buttons = ({ onClickFilters }) => {
    const { handleResetFilters } = useFiltersContext();

    return (
        <div className="d-flex" style={{ gap: '8px' }}>
            <Button
                onClick={onClickFilters}
                variant="outlined"
                startIcon={<IconFilter size={20} />}
                style={{
                    height: '40px',
                    borderRadius: '8px',
                    borderColor: '#E9EAEB',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '14px',
                    padding: '0 16px',
                    color: '#252B37'
                }}
                sx={{
                    '&:hover': {
                        backgroundColor: '#fff',
                        borderColor: '#E9EAEB',
                        boxShadow: 'none'
                    }
                }}
            >
                Filtros
            </Button>
            <Button
                onClick={handleResetFilters}
                variant="outlined"
                style={{
                    height: '40px',
                    borderRadius: '8px',
                    borderColor: '#E9EAEB',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '14px',
                    padding: '0 16px',
                    color: '#252B37'
                }}
                sx={{
                    '&:hover': {
                        backgroundColor: '#fff',
                        borderColor: '#E9EAEB',
                        boxShadow: 'none'
                    }
                }}
            >
                <IconRepeat size={20} />
            </Button>
            <PDFGeneratorButton className={'pdf-button-dashboards'} />
        </div>
    );
};
